export const DATA_EVENT_TYPE = {
  AV_METRIC: 'AV_METRIC',
};

export const EVENT_TYPE = {
  TEACHER_MAPPING_TEACHERS_SEARCHED: 'TEACHER_MAPPING_TEACHERS_SEARCHED',
  TEACHER_MAPPING_ASSIGN_MODAL_OPENED: 'TEACHER_MAPPING_ASSIGN_MODAL_OPENED',
  TEACHER_MAPPING_DEMO_ASSIGN_CLICKED: 'TEACHER_MAPPING_DEMO_ASSIGN_CLICKED',
  MANUAL_DEMO_ASSIGN_CLICKED: 'MANUAL_DEMO_ASSIGN_CLICKED',
  ADD_LEAD: 'ADD_LEAD',
  LEFT_PANEL_CLICK: 'LEFT_PANEL_CLICK',
  HOME_SCREEN_CLICK: 'HOME_SCREEN_CLICK',
  HOME_SCREEN_VIEW: 'HOME_SCREEN_VIEW',
  STUDENT_INFO_SCREEN_VIEW: 'STUDENT_INFO_SCREEN_VIEW',
  MORE_POC_CLICK: 'MORE_POC_CLICK',
  MORE_IDS_CLICK: 'MORE_IDS_CLICK',
  PARENT_NAME_CLICK: 'PARENT_NAME_CLICK',
  TEACHER_NAME_CLICK: 'TEACHER_NAME_CLICK',
  CONTACT_INFO_CLICK: 'CONTACT_INFO_CLICK',
  CREATE_REFUND_CLICK: 'CREATE_REFUND_CLICK',
  DOWNLOAD_INVOICE_CLICK: 'DOWNLOAD_INVOICE_CLICK',
  CANCEL_DEMO_CLICK: 'CANCEL_DEMO_CLICK',
  DEMO_FEEDBACK_CLICK: 'DEMO_FEEDBACK_CLICK',
  PTM_REPORT_CLICK: 'PTM_REPORT_CLICK',
  UPDATE_DEMO_CLICK: 'UPDATE_DEMO_CLICK',
  CANCEL_TRAINING_CLASS_CLICK: 'CANCEL_TRAINING_CLASS_CLICK',
  UPDATE_TRAINING_CLASS_CLICK: 'UPDATE_TRAINING_CLASS_CLICK',
  CLASS_SUMMARY_CLICK: 'CLASS_SUMMARY_CLICK',
  ADD_ON_SCREEN_VIEW: 'ADD_ON_SCREEN_VIEW',
  BASIC_DETAILS_SCREEN_VIEW: 'BASIC_DETAILS_SCREEN_VIEW',
  STUDENT_UPGRADE_CLICK: 'STUDENT_UPGRADE_CLICK',
  STUDENT_UPGRADE_V2_CLICK: 'STUDENT_UPGRADE_V2_CLICK',
  STUDENT_TRIAL_UPGRADE_CLICK: 'STUDENT_TRIAL_UPGRADE_CLICK',
  TRANSFER_CLASS_CLICK: 'TRANSFER_CLASS_CLICK',
  CONVERT_CLASSES_TO_CREDIT_CLICK: 'CONVERT_CLASSES_TO_CREDIT_CLICK',
  MORE_ACTIONS_COURSES: 'MORE_ACTIONS_COURSES',
  COURSES_SCREEN_VIEW: 'COURSES_SCREEN_VIEW',
  GENERATE_PAYMENT_LINK_CLICK: 'GENERATE_PAYMENT_LINK_CLICK',
  PAYMENT_SCREEN_VIEW: 'PAYMENT_SCREEN_VIEW',
  SESSION_SCREEN_VIEW: 'SESSION_SCREEN_VIEW',
  VIEW_DEMO_SLOTS: 'VIEW_DEMO_SLOTS',
  SESSION_INFO_CLICK: 'SESSION_INFO_CLICK',
  EDIT_STUDENT_DETAILS_CLICK: 'EDIT_STUDENT_DETAILS_CLICK',
  ASSIGN_REGION_CLICK: 'ASSIGN_REGION_CLICK',
  ASSIGN_REGION_SUBMIT_CLICKED: 'ASSIGN_REGION_SUBMIT_CLICKED',
  ASSIGN_RM_CLICK: 'ASSIGN_RM_CLICK',
  ASSIGN_RM_SUBMIT_CLICKED: 'ASSIGN_RM_SUBMIT_CLICKED',
  EDIT_LEAP_USERNAME_CLICK: 'EDIT_LEAP_USERNAME_CLICK',
  EDIT_PHONE_NUMBER_CLICK: 'EDIT_PHONE_NUMBER_CLICK',
  EDIT_EMAIL_CLICK: 'EDIT_EMAIL_CLICK',
  EDIT_PHONE_NUMBER_SUBMIT_CLICKED: 'EDIT_PHONE_NUMBER_SUBMIT_CLICKED',
  CREATE_DEMO_WITH_TEACHER_CLICK: 'CREATE_DEMO_WITH_TEACHER_CLICK',
  CREATE_TEST_SLOT_CLICK: 'CREATE_TEST_SLOT_CLICK',
  CREATE_TEST_SLOT_SUBMIT_CLICK: 'CREATE_TEST_SLOT_SUBMIT_CLICK',
  MANAGE_ELECTIVE_COURSES_CLICK: 'MANAGE_ELECTIVE_COURSES_CLICK',
  ELECTIVE_COURSES_MODAL_CONFIRM_CLICKED: 'ELECTIVE_COURSES_MODAL_CONFIRM_CLICKED',
  EDIT_STUDENT_DETAILS_SUBMIT_CLICKED: 'EDIT_STUDENT_DETAILS_SUBMIT_CLICKED',
  EDIT_STUDENT_DETAILS_NEXT_CLICKED: 'EDIT_STUDENT_DETAILS_NEXT_CLICKED',
  EDIT_STUDENT_DETAILS_PREV_CLICKED: 'EDIT_STUDENT_DETAILS_PREV_CLICKED',
  EDIT_LEAP_USERNAME_SUBMIT_CLICKED: 'EDIT_LEAP_USERNAME_SUBMIT_CLICKED',
  ASSIGN_TEACHER_TO_LEAD: 'ASSIGN_TEACHER_TO_LEAD',
  SEND_MATH_CANVAS_OFFER_DETAILS: 'SEND_MATH_CANVAS_OFFER_DETAILS',
  CHANGE_CRM_PARENT: 'CHANGE_CRM_PARENT',
  CHANGE_CRM_GRADE: 'CHANGE_CRM_GRADE',
  RENEWAL_PLAN_DURATIONS: 'RENEWAL_PLAN_DURATIONS',
  TRIAL_UPGRADE_MODAL_VIEW: 'TRIAL_UPGRADE_MODAL_VIEW',
  ASSIGN_TEACHER_TO_SAT_DEMO_CLICKED: 'ASSIGN_TEACHER_TO_SAT_DEMO_CLICKED',
  SAT_DEMO_ASSIGNED: 'SAT_DEMO_ASSIGNED',
  SAT_DEMO_ASSIGNED_FAILED: 'SAT_DEMO_ASSIGNED_FAILED',
  // Trial Dashboard Events
  TRIAL_DASHBOARD_VIEW: 'TRIAL_DASHBOARD_VIEW',
  TRIAL_DASHBOARD_SEARCH: 'TRIAL_DASHBOARD_SEARCH',
  TRIAL_DASHBOARD_FILTER_APPLIED: 'TRIAL_DASHBOARD_FILTER_APPLIED',
  TRIAL_DASHBOARD_DATE_FILTER_APPLIED: 'TRIAL_DASHBOARD_DATE_FILTER_APPLIED',
  TRIAL_DASHBOARD_VIEW_TRIAL_CLICKED: 'TRIAL_DASHBOARD_VIEW_TRIAL_CLICKED',
  TRIAL_DASHBOARD_STUDENT_NAME_CLICKED: 'TRIAL_DASHBOARD_STUDENT_NAME_CLICKED',
  TRIAL_DASHBOARD_TUTOR_NAME_CLICKED: 'TRIAL_DASHBOARD_TUTOR_NAME_CLICKED',
  TRIAL_ANNOTATION_PAGE_VIEW: 'TRIAL_ANNOTATION_PAGE_VIEW',
  TRIAL_ANNOTATION_CREATED: 'TRIAL_ANNOTATION_CREATED',
  TRIAL_ANNOTATION_EDITED: 'TRIAL_ANNOTATION_EDITED',
  TRIAL_ANNOTATION_DELETED: 'TRIAL_ANNOTATION_DELETED',
  TRIAL_ANNOTATION_CREATE_FAILED: 'TRIAL_ANNOTATION_CREATE_FAILED',
  TRIAL_ANNOTATION_EDIT_FAILED: 'TRIAL_ANNOTATION_EDIT_FAILED',
  TRIAL_ANNOTATION_DELETE_FAILED: 'TRIAL_ANNOTATION_DELETE_FAILED',
  TRIAL_TRANSCRIPT_GENERATE_CLICKED: 'TRIAL_TRANSCRIPT_GENERATE_CLICKED',
  TRIAL_TRANSCRIPT_GENERATED: 'TRIAL_TRANSCRIPT_GENERATED',
  TRIAL_TRANSCRIPT_GENERATION_FAILED: 'TRIAL_TRANSCRIPT_GENERATION_FAILED',
  TRIAL_SALES_PITCH_GENERATE_CLICKED: 'TRIAL_SALES_PITCH_GENERATE_CLICKED',
  TRIAL_SALES_PITCH_GENERATED: 'TRIAL_SALES_PITCH_GENERATED',
  TRIAL_SALES_PITCH_GENERATION_FAILED: 'TRIAL_SALES_PITCH_GENERATION_FAILED',
  TRIAL_AI_ANALYSIS_GENERATE_CLICKED: 'TRIAL_AI_ANALYSIS_GENERATE_CLICKED',
  TRIAL_AI_ANALYSIS_GENERATED: 'TRIAL_AI_ANALYSIS_GENERATED',
  TRIAL_AI_ANALYSIS_GENERATION_FAILED: 'TRIAL_AI_ANALYSIS_GENERATION_FAILED',
  // Classroom Analysis Hub — Regular Classes Events
  CLASSROOM_DASHBOARD_VIEW: 'CLASSROOM_DASHBOARD_VIEW',
  CLASSROOM_SEARCH: 'CLASSROOM_SEARCH',
  CLASSROOM_VIEW_CLICKED: 'CLASSROOM_VIEW_CLICKED',
  CLASSROOM_NO_RECORDING: 'CLASSROOM_NO_RECORDING',
  CLASSROOM_COMPOSE_TRIGGERED: 'CLASSROOM_COMPOSE_TRIGGERED',
  CLASSROOM_VIDEO_VIEW: 'CLASSROOM_VIDEO_VIEW',
};
